import { render, staticRenderFns } from "./CurriculumSelectDialog.vue?vue&type=template&id=0da53ace&scoped=true"
import script from "./CurriculumSelectDialog.ts?vue&type=script&lang=ts&external"
export * from "./CurriculumSelectDialog.ts?vue&type=script&lang=ts&external"
import style0 from "./CurriculumSelectDialog.scss?vue&type=style&index=0&id=0da53ace&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da53ace",
  null
  
)

export default component.exports